import API from '../api';

export const getInterviewQuestions = ({
  params: { page, uuid, page_size } = {},
  signal,
} = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/interviews/interview_questions/`, {
        params: { page, page_size },
        signal,
      })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const postInterviewQuestion = ({ interview, question } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.post('/interviews/interview_questions/', {
        interview,
        question,
      })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const patchInterviewQuestion = (
  uuid,
  { interview, question, interview_sequence } = {},
) => {
  return new Promise((resolve, reject) => {
    try {
      API.patch(`/interviews/interview_questions/${uuid}/`, {
        interview,
        question,
        interview_sequence,
      })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const deleteInterviewQuestion = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      API.delete(`/interviews/interview_questions/${uuid}/`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};
